import { render } from "./OurTeam.vue?vue&type=template&id=0ec7e008&scoped=true"
const script = {}

import "./OurTeam.vue?vue&type=style&index=0&id=0ec7e008&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec7e008"]])

export default __exports__